<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent">{{ title }}</h2>
        <div class="top_musica" v-if="showContent">
          <loading v-if="! showContent"></loading>
          <ul>
            <li v-for="(item, index) in items" >
              <a href="" v-if="item.codevideo" @click="setVideoShow(item.codevideo)">
                <span>{{ (index + 1) }}</span>
                <small> {{ item.nameArtist }}</small>
                <strong>{{ item.nameMusic }}</strong>
              </a>
              <div v-if="!item.codevideo">
                <span>{{ (index + 1) }}</span>
                <small>{{ item.nameArtist }}</small>
                <strong>{{ item.nameMusic }}</strong>
              </div>
            </li>
          </ul>
        </div>

        <div class="modal fade modal_videos" id="myModalTops" role="dialog" ref="vueModalTopMusics">
          <div class="modal-dialog">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-content embed-responsive embed-responsive-16by9" role="dialog">
              <iframe class="embed-responsive-item" :src="urlShowVideo" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Top músicas',
        showContent: true,
        urlShowVideo:'',
        items: []
      }
    },
    methods:{
      setVideoShow(video) {
        event.preventDefault();
        $('#myModalTops').modal();
        this.urlShowVideo = "https://www.youtube.com/embed/" + video;
        return this.urlShowVideo;
      },
      onHidden() {
        this.urlShowVideo = null;
        $("#myModalTops iframe").attr("src", $("#myModalTops iframe").attr("src"));
      }
    },
    mounted(){
      $(this.$refs.vueModalTopMusics).on("hidden.bs.modal", this.onHidden)
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }

      function compare(a, b) {
        let comparison = 0;

        if (a.order > b.order) {
          comparison = 1;
        } else if (b.order > a.order) {
          comparison = -1;
        }

        return comparison;
      }

      let self = this;
      // get('content/'+this.bloco.id).then(function (response) {
      //     self.showContent = true;
      self.items = this.$store.getters['getSiteContent'].result.data.topmusica;
      // self.items = window.siteconfig.result.data.topmusica;
      self.items.sort(compare);
      // });
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/TopMusicsList.vue